import axiosNest from '../api/axiosNest';
import { toErrorMessage } from '../admin/userOffers/orderActionsApi';

/**
 * Zawartość komunikatu VIA — odczyt (W11).
 *
 * Odpowiada `GET /via-orders/:id/content`. Kolumny tabeli niosą wyłącznie
 * nagłówek; stacje, przesyłki i pozycje siedzą w zapisanym poddrzewie `<tour>`
 * i są normalizowane po stronie API — tą samą funkcją, której używa parser
 * przy wczytywaniu pliku.
 */

export interface ItemQuantity {
  qualifier: string;
  unit: string | null;
  value: string | null;
}

export interface ShipmentItem {
  id: string | null;
  posIndex: string | null;
  description: string | null;
  shortDescription: string | null;
  materialNumber: string | null;
  quantities: ItemQuantity[];
}

export interface Shipment {
  id: string | null;
  number: string | null;
  customerName: string | null;
  customerNumber: string | null;
  weight: number | null;
  weightUnit: string | null;
  route: number | null;
  items: ShipmentItem[];
}

export interface MessageStation {
  id: string | null;
  type: string | null;
  companyName: string | null;
  address: string | null;
  zip: string | null;
  city: string | null;
  countryId: string | null;
  fromDate: string | null;
  fromTime: string | null;
  untilDate: string | null;
  untilTime: string | null;
  fixedDate: string | null;
  avis: string | null;
  comment: string | null;
  shipment: string | null;
  sequence: number;
}

export interface QuantityTotal {
  qualifier: string;
  unit: string | null;
  total: number;
  unparsed: number;
}

export interface MessageContent {
  id: number;
  transportId: string;
  orderNumber: string | null;
  messageType: string;
  shipments: Shipment[];
  stacje: MessageStation[];
  quantities: QuantityTotal[];
  ostrzezenia: string[];
}

export async function fetchMessageContent(
  id: number | string,
): Promise<MessageContent> {
  const { data } = await axiosNest.get<MessageContent>(
    `/via-orders/${id}/content`,
  );
  return data;
}

export { toErrorMessage };
